import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breacrumb-company-user-add',
    templateUrl: './breadcrumb.company.user.add.component.html'
})

export class BreadcrumbCompanyUserAddComponent {
    roleMatrix: RoleMatrix;

    @Input() companyId: number;
    @Input() filteredUserType: string;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}

